exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company h1[data-v-7b2acec6]{font-size:28px;font-weight:400}.company .regards .main[data-v-7b2acec6]{line-height:30px}.company .introduce[data-v-7b2acec6]{margin:30px 0;font-size:15px;line-height:30px;text-indent:30px}.company .introduce img[data-v-7b2acec6]{max-width:100%!important;height:auto!important}.company .imageRes[data-v-7b2acec6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:620px}.company .imageRes img[data-v-7b2acec6]{max-width:100%!important;height:auto!important}", ""]);

// exports
